/**
 * The error codes of this area of the admin API and the auth routes (see
 * `./index.ts`). One entry per message the backend can send; the panel
 * translates `errors.<code>`.
 */
export const CABINET_ERROR_CODES = [
  'CABINET_CONFIGURATIONS_INVALID',
  'CABINET_CREDITS_CHANGED',
  'CABINET_GAME_ROUND_OPEN',
  'CABINET_LOCATION_NOT_IN_TENANT',
  'CABINET_NOT_ACTIVE',
  'CABINET_NOT_IDLE',
  'ONLY_PLATFORM_ADMINS_OPEN_TEST_CABINETS',
  'TEST_CABINET_NEEDS_PLATFORM_CONFIGURATION',
  'TEST_CABINET_VERSION_SUPERSEDED',
  'TEST_SEEDS_NOT_ALLOWED',
] as const
